import { render } from "./TopSearch.vue?vue&type=template&id=3cdf3f8a"
import script from "./TopSearch.vue?vue&type=script&lang=js"
export * from "./TopSearch.vue?vue&type=script&lang=js"
script.render = render

export default script